import React from "react";
import "./footer.css"

export default function Footer(){
    return(
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">Elyas</h1>
                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>
                    <li>
                        <a href="#portfolio" className="footer__link">Projects</a>
                    </li>
                    <li>
                        <a href="#testimonials" className="footer__link">Testimonials</a>
                    </li>
                </ul>
            <div className="footer__social">
                <a href="https://www.linkedin.com/in/elyas-afghan-225394222/" className="home__social-icon" target="_blank">
                <i class='bx bxl-linkedin-square' ></i>
                </a>
                <a href="https://youtube.com/@javascriptdaily" className="home__social-icon" target="_blank">
                    <i class='bx bxl-youtube'></i>
                </a>
                <a href="https://twitter.com/AfghanElyas1" className="home__social-icon" target="_blank">
                    <i class='bx bxl-twitter'></i>   
                </a>
            </div>
            <p className="footer__copy">&#169; 2023 Elyas Afghan. All right reserved</p>
            </div>
        </footer>
    )
}